import { FeatureMouseInteraction } from '@openlayers/interaction/FeatureMouseInteraction';
import { MapOverlays } from '@openlayers/ol-overlays';
import { declusterFeature, isCluster, setMapCursor } from '@openlayers/ol-utils';
import { mapUI, mapWrapper } from '@pages/map/map';
import { ReactUtils } from '@shared/ui-react/ReactUtils';
import { DateUtils } from '@shared/utils/DateUtils';
import { getFilenameWithVersion } from '@shared/utils/utils';
import Feature from 'ol/Feature';
import React from 'react';
import { ImageListMapCluster } from '../../../shared/documents-images/ui/ImageListMapCluster';


export class ImageDesktopMouseInteraction extends FeatureMouseInteraction {

    onClick = (feature: Feature, e, n): void => {
        // clicked cluster > print list of images inside
        if (isCluster(feature)) {
            const clusterFeatures: Feature[] = feature.get('features');

            const [lat, lon] = clusterFeatures[0].getGeometry().getExtent();
            const sortedImages = clusterFeatures.map(f => f.get('data')).sort((a: IImage, b: IImage) => {
                return (b.timestamp || b.originalDate) - (a.timestamp || a.originalDate);
            });
            const dialog = MapOverlays.showDialog(this.map, null, lat, lon, feature);
            ReactUtils.safeRender(<div style={{ width: '400px', maxHeight: '40vh', overflow: 'auto' }}>
                <ImageListMapCluster
                    images={sortedImages}
                    onOpen={image => mapWrapper.featureLayers.images.openImageById(image.id, sortedImages.map(f => f.id), false)}
                    onEdit={image => mapUI.editImage(image.id)}
                /></div>, dialog.getElement());

        }
        // clicked single unclastered image
        else if (feature) {
            mapWrapper.featureLayers.images.openImageById(feature.get('data')?.id, null, false);
        }
    };

    onMouseOver = (feature: Feature, e, n): void => {
        setMapCursor(this.map, 'pointer');
        if (!feature || isCluster(feature)) return;

        feature = declusterFeature(feature);
        const data: IImage = feature.get('data');
        const imgPath = kuura.getContextPath() + '/api/1/image/' + data.id + '_t.jpg';
        MapOverlays.showTooltip(this.map, `<div class='text-center'><img class="card" style='display: inline-block' src="${imgPath}" width='120px'/></div>
<div class="card padded-half" style='font-size: 12px;'><strong>${getFilenameWithVersion(data)}</strong><div style="max-width: 400px" class="ellipsis">${data.description}</div><div>${DateUtils.formatDateTime(data.originalDate || data.timestamp)}</div></div>`, e, n);
    };
}
